<script lang="ts">
	import { irrigationZoneColors } from 'src/helpers/xt1_helpers/irrigation/irrigation_helpers';

	export let index: number,
		inactive: boolean = false;
</script>

<div class={`zone-card${inactive ? ' inactive' : ''}`}>
	<div class="zone-number" style="background:{irrigationZoneColors[index]}">
		{index + 1}
	</div>
	<div class="zone-info">
		<slot name="main" />
	</div>
	<slot name="control" />
</div>

<style>
	.zone-card {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 16px 20px;
		background: #121517;
		border-radius: 10px;
		transition: background 0.2s ease;
		margin-bottom: 12px;
	}
	.zone-card:last-child {
		margin-bottom: 0;
	}
	.zone-card.inactive {
		opacity: 0.5;
		pointer-events: none;
	}
	.zone-number {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-weight: 600;
		color: white;
		flex-shrink: 0;
	}
	.zone-info {
		flex: 1;
	}
</style>
